import { errorCode } from '../http/errorStatus'

/** Backend `SaivaErrorCode` raised when a live key of the organisation already has the name. */
export const API_KEY_NAME_EXISTS_CODE = 'integration_api_key_name_exists'

export type ApiKeyFailure = 'nameExists' | 'unknown'

/** Maps a failed create/update to the message the form can show for it. */
export function classifyApiKeyError(error: unknown): ApiKeyFailure {
  return errorCode(error) === API_KEY_NAME_EXISTS_CODE ? 'nameExists' : 'unknown'
}
